import { HttpClient, buildUserSearchResultViewModel } from "@utils/index";
import type {
  IUserSearchResultModel,
  IUserSearchResultViewModel,
} from "@models/index";

const BASE_URL = import.meta.env.VITE_XPLATFORM_CORE_API_BASE_URL;

if (!BASE_URL) {
  throw new Error(
    "Missing required environment variable: VITE_XPLATFORM_CORE_API_BASE_URL. " +
      "Please check your .env file and ensure the XPlatform Core API URL is set.",
  );
}

class XPlatformCoreApi {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(`${BASE_URL}`);
  }

  async searchUsers(
    query: string,
    limit: number = 10,
  ): Promise<IUserSearchResultViewModel[]> {
    const params = new URLSearchParams({ q: query, limit: limit.toString() });
    const results = await this.httpClient.makeAuthenticatedRequest<
      IUserSearchResultModel[]
    >(`/users/search?${params.toString()}`, { method: "GET" });
    return results.map(buildUserSearchResultViewModel);
  }
}

export const xplatformCoreApi = new XPlatformCoreApi();
